import "app/style/app.css";
import {Route, Routes} from "react-router";
import {MyRecipes} from "app/recipe/MyRecipes";
import {Recipe} from "app/recipe/Recipe";
import {Shell} from "app/nav/Shell";
import {useGlobalState} from "app/user/GlobalStateProvider";
import {RegisterForm} from "app/user/RegisterForm";
import LoginForm from "app/user/LoginForm";
import {Loading} from "app/components/Loading";
import {AuthWrapper} from "app/user/AuthWrapper";
import {NotFound} from "app/user/NotFound";
import {Home} from "app/Home";

export const App = () => {
  const {initialized} = useGlobalState();

  if (!initialized) {
    return <Loading />;
  }

  return (
    <Shell>
      <Routes>
        <Route element={<RegisterForm />} path="/user/register" />
        <Route element={<LoginForm />} path="/user/login" />
        <Route element={<Home />} path="/" />
        <Route element={<AuthWrapper />}>
          <Route element={<Recipe />} path="/my-recipes/:id" />
          <Route element={<MyRecipes />} path="/my-recipes" />
        </Route>
        <Route element={<NotFound />} path="*" />
      </Routes>
    </Shell>
  );
};
